( function () {
	'use strict';
	/* eslint-disable max-params */
	function ViewSchedules ( logger, $location, $filter, scheduleservice, createschedservice, editschedservice, deleteschedservice, SCHEDULE_MESSAGES, $rootScope ) {
		var self = this;

		self.title        = 'View Schedule';
		self.inviteeTitle = SCHEDULE_MESSAGES.invitee;

		function getObserveeName ( observeeId ) {
			var observee     = editschedservice.getObservee( self.schools, observeeId );
			var observeeName = editschedservice.getSessionCredentials().FirstName + ' ' + editschedservice.getSessionCredentials().LastName;

			if ( observee && editschedservice.getSessionCredentials().userId !== observeeId ) {
				observeeName = observee.FirstName + ' ' + observee.LastName;
			}

			return observeeName;
		}

		function getTemplateName ( schedule ) {
			var template = '';
			var statuses = [ 'Completed', 'In Progress', 'Scheduled' ];

			if ( statuses.indexOf( schedule.status ) > -1 && schedule.template.name ) {
				template = schedule.template.name;
			}

			return template;
		}

		function schedListMapper ( schedule ) {
			schedule.standardizedDate = scheduleservice.getStandardizeDate( schedule );
			schedule.searchList       = [
				schedule.name,
				scheduleservice.getSearchableDate( schedule )
			];

			if ( schedule.meta ) {
				schedule.searchList.push( schedule.templateName || '' );

				( schedule.meta.invitees || [ ] ).map( function ( invitee ) {
					schedule.searchList.push( getObserveeName( invitee ) );
				} );

				if ( schedule.meta.observee ) {
					schedule.searchList.push( getObserveeName( schedule.meta.observee[ 0 ] ) );
				}
			}
		}

		function deleteObsModal ( obsId ) {
			deleteschedservice.deleteObsModal( obsId )
				.then( function () {
					self.schedules = self.schedules.filter( function ( item ) {
						return item.id !== obsId;
					} );

					$rootScope.$broadcast( 'schedules:delete:event', obsId );
				} );
		}

		function deleteEventModal ( eventModel ) {
			deleteschedservice.openModal( eventModel )
				.then( function () {
					self.schedules = self.schedules.filter( function ( item ) {
						return item.id !== eventModel.id;
					} );

					$rootScope.$broadcast( 'schedules:delete:event', eventModel.id );
				} );
		}

		function activate ( templates ) {
			logger.info( 'Activated View Schedules View' );
			self.templates = templates;

			self.preActiveScheds.map( schedListMapper );
			self.schedules   = self.preActiveScheds;
			self.currentPage = 1;
			self.pageSize    = 25;
			self.maxSize     = 10;
			self.fetching    = false;

			// handlers
			self.getObserveeName    = getObserveeName;
			self.getTemplateName    = getTemplateName;
			self.confirmStartObs    = scheduleservice.confirmStartObs;
			self.editSchedHandler   = editschedservice.openModal;
			self.deleteSchedHandler = deleteEventModal;
			self.deleteObsModal     = deleteObsModal;
		}

		function schoolsResult ( districts ) {
			var schools = [ ];

			// look into all districts
			( districts || [ ] ).map( function ( district ) {
				schools = schools.concat( district.Schools || [ ] );
			} );

			self.schools = schools;

			createschedservice.getTemplates()
				.then( activate );
		}

		function errorScheds () {
			self.schedules   = [ ];
			self.currentPage = 1;
			self.pageSize    = 25;
			self.maxSize     = 10;
			self.fetching    = false;
		}

		function schedsResult ( schedules ) {
			self.preActiveScheds = schedules;

			if ( schedules.length ) {
				createschedservice.getSchools()
					.then( schoolsResult );
			} else {
				errorScheds();
			}
		}

		scheduleservice.getSchedules()
			.then( schedsResult, errorScheds );

		// defaults
		self.sort     = 'startDate';
		self.fetching = true;
	}

	angular
		.module( 'app.schedules' )
		.controller( 'ViewSchedules', ViewSchedules );

	ViewSchedules.$inject = [ 'logger', '$location', '$filter', 'scheduleservice', 'createschedservice', 'editschedservice', 'deleteschedservice', 'SCHEDULE_MESSAGES', '$rootScope' ];
} )( );
